const conf = APP_CONFIG // eslint-disable-line

const AUTHORIZE_ENDPOINT = conf.auth.authorizationEndpoint

export default function authorize(idToken, application, dev) {
  if (!idToken || !application) throw 'IdToken or Application must be specified'

  let headers = new Headers({
    Authorization: `Bearer ${idToken}`,
    application
  })

  return fetch(AUTHORIZE_ENDPOINT, {
    headers,
    method: 'GET',
    cache: 'default',
    mode: 'cors'
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((message) => {
        throw message
      })
    }
    return response.json()
  })
}



// WEBPACK FOOTER //
// ./src/lib/auth/authorizations.js